'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  VersionSnippet: {
    displayName: 'VersionSnippet'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/VersionSnippet/VersionSnippet.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import GeminiScrollbar from 'react-gemini-scrollbar';


// import styles from '../../../node_modules/react-gemini-scrollbar/node_modules/gemini-scrollbar/gemini-scrollbar.css';
// require("style!css!./file.css").
// import '../../../node_modules/gemini-scrollbar/gemini-scrollbar.css';
// require('style!css!../../../node_modules/gemini-scrollbar/gemini-scrollbar.css');


var VersionSnippet = _wrapComponent('VersionSnippet')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(VersionSnippet, _Component);

  function VersionSnippet() {
    (0, _classCallCheck3.default)(this, VersionSnippet);
    return (0, _possibleConstructorReturn3.default)(this, (VersionSnippet.__proto__ || (0, _getPrototypeOf2.default)(VersionSnippet)).apply(this, arguments));
  }

  (0, _createClass3.default)(VersionSnippet, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isActive = _props.isActive,
          version = _props.version,
          date = _props.date;

      var styles = require('./VersionSnippet.scss');
      var activePan = isActive ? _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'pushpin' }),
        _react3.default.createElement(
          'b',
          null,
          'Aktu\xE1ln\xED verze'
        )
      ) : null;

      return _react3.default.createElement(
        'div',
        { className: 'scrollable ' + styles.versionSnippet + (isActive ? ' ' + styles.active : '') },
        _react3.default.createElement(
          'div',
          { className: styles.date },
          date
        ),
        _react3.default.createElement(
          'h2',
          null,
          version
        ),
        activePan,
        _react3.default.createElement('hr', null),
        'Seznam zm\u011Bn: ',
        _react3.default.createElement('br', null),
        _react3.default.createElement('hr', null),
        this.props.children
      );
    }
  }]);
  return VersionSnippet;
}(_react2.Component), _class.propTypes = {
  isActive: _react2.PropTypes.bool,
  version: _react2.PropTypes.string,
  date: _react2.PropTypes.string,
  children: _react2.PropTypes.oneOfType([_react2.PropTypes.arrayOf(_react3.default.PropTypes.node), _react2.PropTypes.node])
}, _temp));

exports.default = VersionSnippet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/VersionSnippet/VersionSnippet.js
// module id = 1199
// module chunks = 0